"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchRentalInvoiceAnalysisQuery = exports.useApproveSelectionMutation = exports.useSaveSelectionMutation = exports.useFetchSelectionQuery = exports.useLazyFetchAnalysisNoteAttachmentUrlQuery = exports.useUploadAnalysisNoteAttachmentMutation = exports.useDeleteAnalysisNoteMutation = exports.useCreateAnalysisNoteMutation = exports.useFetchAnalysisNotesQuery = exports.useLazyExportAnalysisQuery = exports.useFetchAnalysisQuery = exports.analysisApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.analysisApi = (0, react_1.createApi)({
    reducerPath: "analysisApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["analysis", "analysisNotes", "selection"],
    endpoints: function (builder) { return ({
        fetchAnalysis: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    buildingId: obj.buildingId,
                    startPeriod: obj.startPeriod,
                    endPeriod: obj.endPeriod,
                };
                if (obj.mode)
                    params.mode = obj.mode;
                if (obj.responsibleParty)
                    params.responsibleParty = obj.responsibleParty;
                if (obj.chargeType)
                    params.chargeType = obj.chargeType;
                if (obj.chargeCategory)
                    params.chargeCategory = obj.chargeCategory;
                if (obj.tenantName)
                    params.tenantName = obj.tenantName;
                return {
                    url: "/v1/analysis/consumption",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["analysis"],
        }),
        exportAnalysis: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    buildingId: obj.buildingId,
                    startPeriod: obj.startPeriod,
                    endPeriod: obj.endPeriod,
                    format: "csv",
                };
                if (obj.mode)
                    params.mode = obj.mode;
                if (obj.responsibleParty)
                    params.responsibleParty = obj.responsibleParty;
                if (obj.chargeType)
                    params.chargeType = obj.chargeType;
                if (obj.chargeCategory)
                    params.chargeCategory = obj.chargeCategory;
                if (obj.tenantName)
                    params.tenantName = obj.tenantName;
                return {
                    url: "/v1/analysis/export",
                    method: "GET",
                    params: params,
                    responseHandler: function (response) { return response.blob(); },
                };
            },
        }),
        fetchAnalysisNotes: builder.query({
            query: function (obj) { return ({
                url: "/v1/analysis/notes",
                method: "GET",
                params: { clientId: obj.clientId, buildingId: obj.buildingId },
            }); },
            providesTags: ["analysisNotes"],
        }),
        createAnalysisNote: builder.mutation({
            query: function (body) { return ({
                url: "/v1/analysis/notes",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["analysisNotes"],
        }),
        deleteAnalysisNote: builder.mutation({
            query: function (_a) {
                var noteId = _a.noteId, userId = _a.userId;
                return ({
                    url: "/v1/analysis/notes/".concat(noteId),
                    method: "DELETE",
                    params: { userId: userId },
                });
            },
            invalidatesTags: ["analysisNotes"],
        }),
        uploadAnalysisNoteAttachment: builder.mutation({
            query: function (_a) {
                var noteId = _a.noteId, formData = _a.formData;
                return ({
                    url: "/v1/analysis/notes/".concat(noteId, "/attachment"),
                    method: "POST",
                    body: formData,
                });
            },
            invalidatesTags: ["analysisNotes"],
        }),
        fetchAnalysisNoteAttachmentUrl: builder.query({
            query: function (noteId) { return ({
                url: "/v1/analysis/notes/".concat(noteId, "/attachment/url"),
                method: "GET",
            }); },
        }),
        fetchSelection: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId, period = _a.period;
                return ({
                    url: "/v1/analysis/selection",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId, period: period },
                });
            },
            providesTags: ["selection"],
        }),
        saveSelection: builder.mutation({
            query: function (body) { return ({
                url: "/v1/analysis/selection",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["selection"],
        }),
        approveSelection: builder.mutation({
            query: function (body) { return ({
                url: "/v1/analysis/selection/approve",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["selection"],
        }),
        fetchRentalInvoiceAnalysis: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId, invoiceType = _a.invoiceType;
                return ({
                    url: "/v1/analysis/rental",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId, invoiceType: invoiceType },
                });
            },
            providesTags: ["analysis"],
        }),
    }); },
});
exports.useFetchAnalysisQuery = exports.analysisApi.useFetchAnalysisQuery, exports.useLazyExportAnalysisQuery = exports.analysisApi.useLazyExportAnalysisQuery, exports.useFetchAnalysisNotesQuery = exports.analysisApi.useFetchAnalysisNotesQuery, exports.useCreateAnalysisNoteMutation = exports.analysisApi.useCreateAnalysisNoteMutation, exports.useDeleteAnalysisNoteMutation = exports.analysisApi.useDeleteAnalysisNoteMutation, exports.useUploadAnalysisNoteAttachmentMutation = exports.analysisApi.useUploadAnalysisNoteAttachmentMutation, exports.useLazyFetchAnalysisNoteAttachmentUrlQuery = exports.analysisApi.useLazyFetchAnalysisNoteAttachmentUrlQuery, exports.useFetchSelectionQuery = exports.analysisApi.useFetchSelectionQuery, exports.useSaveSelectionMutation = exports.analysisApi.useSaveSelectionMutation, exports.useApproveSelectionMutation = exports.analysisApi.useApproveSelectionMutation, exports.useFetchRentalInvoiceAnalysisQuery = exports.analysisApi.useFetchRentalInvoiceAnalysisQuery;
